import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { withRouter } from 'react-router-dom';

import { login, cleanErrors } from 'modules/auth';

import LoginForm from 'components/login/LoginForm';


/** Redux container for the login form */
class LoginFormContainer extends Component {

    static propTypes = {
        auth: PropTypes.object //The auth object
    };

    componentWillMount() {
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillUnmount() {
        const { dispatch } = this.props;

        dispatch(cleanErrors());
    }

    componentWillUpdate(nextProps) {
        const {
            auth,
            nextPathname,
            dispatch
        } = this.props;

        if (auth !== nextProps.auth || nextPathname !== nextProps.nextPathname) {
            if (auth.isLoggedIn) {
                if (nextPathname) {
                    dispatch(routerActions.push(nextPathname));
                } else {
                    dispatch(routerActions.push('/'));
                }
            }
        }
    }

    handleSubmit(user, pass, remember) {
        const { dispatch } = this.props;

        dispatch(login(user, pass, remember));
    }

    render() {
        const { auth:{isFetching, loginError, remember}} = this.props;

        const loginErrorMessage = typeof loginError === 'string' ? loginError : loginError && loginError.message;

        return (
            <LoginForm
                onSubmit={this.handleSubmit}
                isFetching={isFetching}
                loginError={loginErrorMessage}
                remember={remember}
            />
        );
    }
}

const mapStateToProps = state => ({
    auth:    state.auth,
    routing: state.routing
});

export default withRouter(connect(mapStateToProps)(LoginFormContainer));



// WEBPACK FOOTER //
// ./src/containers/login/LoginFormContainer.jsx